import React from 'react';
import styled from 'styled-components';
import { BrowserRouter as Router, Route, Link, withRouter } from "react-router-dom";

const StyledSideNav = styled.div`   
    position: fixed;     /* Fixed Sidebar (stay in place on scroll and position relative to viewport) */
    height: 100%;
    width: 140px;     /* Set the width of the sidebar */
    z-index: 1;      /* Stay on top of everything */
    top: 3.4em;      /* Stay at the top */
    background-color: #E5E7E9; /* Black */
    overflow-x: hidden;     /* Disable horizontal scroll */
    padding-top: 5px;
    padding-left:10px;
    padding-bottom:10px;
`;

class SideNav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activePath: props.location.pathname,
            items: [
              {
                path: '/components/Kotlin/KTextView',
                name: 'Kotlin',
                css: 'fas fa-hashtag',
                key: 1
              },
               
                {
                  path: '/components/java/textview',
                  name: 'TextView',
                  css: 'fa fa-fw fa-clock',
                  key: 2
                },
                {
                  path: '/components/java/edittext',
                  name: 'EditText',
                  css: 'fas fa-hashtag',
                  key: 3
                },
                {
                    path: '/components/java/button',
                    name: 'Button',
                    css: 'fas fa-hashtag',
                    key: 4
                  },
                 
                  {
                    path: '/components/java/checkbox',
                    name: 'CheckBox',
                    css: 'fas fa-hashtag',
                    key: 5
                  },
                  {
                    path: '/components/java/checkbox',
                    name: 'RatingBar',
                    css: 'fas fa-hashtag',
                    key: 6
                  },
                  {
                    path: '/components/java/progressBar',
                    name: 'ProgressBar',
                    css: 'fas fa-hashtag',
                    key: 7
                  },
                  {
                    path: '/components/java/seekbar',
                    name: 'SeekBar',
                    css: 'fas fa-hashtag',
                    key: 8
                  },
                  {
                    path: '/components/java/seekbar',
                    name: 'Switch',
                    css: 'fas fa-hashtag',
                    key: 9
                  },
                  {
                    path: '/components/java/seekbar',
                    name: 'ToggleButton',
                    css: 'fas fa-hashtag',
                    key: 10
                  },
                  {
                    path: '/components/java/seekbar',
                    name: 'Spinner',
                    css: 'fas fa-hashtag',
                    key: 11
                  },
                  {
                    path: '/components/java/seekbar',
                    name: 'TextSwitcher',
                    css: 'fas fa-hashtag',
                    key: 12
                  },
                  {
                    path: '/components/java/seekbar',
                    name: 'ImageSwitcher',
                    css: 'fas fa-hashtag',
                    key: 13
                  },
                  {
                    path: '/components/java/seekbar',
                    name: 'ImageButton',
                    css: 'fas fa-hashtag',
                    key: 14
                  },
                  {
                    path: '/components/java/seekbar',
                    name: 'ImageView',
                    css: 'fas fa-hashtag',
                    key: 15
                  },
                  {
                    path: '/components/java/seekbar',
                    name: 'VideoView',
                    css: 'fas fa-hashtag',
                    key: 16
                  },
                  {
                    path: '/components/java/seekbar',
                    name: 'TextClock',
                    css: 'fas fa-hashtag',
                    key: 17
                  },
                  {
                    path: '/components/java/seekbar',
                    name: 'DatePicker',
                    css: 'fas fa-hashtag',
                    key: 18
                  },
                  {
                    path: '/components/java/radiobutton',
                    name: 'RadioButton',
                    css: 'fas fa-hashtag',
                    key: 19
                  },
              ]
        }
    }

    onItemClick = (path) => {
        this.setState({ activePath: path });
    }

    render() {
        const { items, activePath } = this.state;
        return(
            <StyledSideNav>
                {
                    items.map((item) => {
                        return (
                            <NavItem 
                                path={item.path}
                                name={item.name}
                                // css={item.css}
                                onItemClick={this.onItemClick}
                                active={item.path === activePath}
                                key={item.key}
                            />
                        );
                    })
                }
            </StyledSideNav>
        );
    }
}

const RouterSideNav = withRouter(SideNav);

const StyledNavItem = styled.div`
    height: 40px;
    width: 75px; /* width must be same size as NavBar to center */
    text-align: center; /* Aligns <a> inside of NavIcon div */
    margin-bottom: 0;   /* Puts space between NavItems */
    a {
        font-size: 1em;
        color: ${(props) => props.active ? "blue" : "#222"};
        :hover {
            opacity: 0.7;
            text-decoration: none; /* Gets rid of underlining of icons */
        }  
    }
`;

class NavItem extends React.Component {
    handleClick = () => {
        const { path, onItemClick } = this.props;
        onItemClick(path);
    }

    render() {
        const { active } = this.props;
        return(
            <StyledNavItem active={active}>
                <Link to={this.props.path} className={this.props.css} onClick={this.handleClick}>
                {this.props.name}
                </Link>
            </StyledNavItem>
        );
    }
}

const NavIcon = styled.div`

`;

export default class Sidebar extends React.Component {
    render() {
        return (
            <RouterSideNav></RouterSideNav>
        );
    }
}